<div
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-at="modal-holdings"
>
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title">
          {{ 'HOLDINGS_EDIT_TITLE' | countrify }}
        </div>
        <div class="navbar__section navbar__section--right">
          <gk-icon-button icon="close" (buttonClick)="close()"></gk-icon-button>
        </div>
      </div>
    </div>

    <gk-edit-holdings-form
      #editHoldingsForm
      (saveForm)="saveHoldings()"
      [businessId]="businessId"
      [holdings]="holdings"
      [regions]="regions"
    >
    </gk-edit-holdings-form>

    <!-- Not ideal, but the styling messes up if you don't have this outside of
    the above form component :( -->
    <footer
      class="toolbar modal__content__footer u-justify-space-between tw-pl-6"
    >
      <button
        type="button"
        class="btn btn--primary add-new"
        data-at="list-button-add"
        (click)="editHoldingsForm.addHolding()"
      >
        <i data-icon="add"></i>
        <span>{{ 'HOLDINGS_NEW_LABEL' | countrify }}</span>
      </button>
      <gk-icon-button
        type="submit"
        btnType="square-fill"
        icon="check"
        size="compact"
        (buttonClick)="editHoldingsForm.save()"
        data-at="button-save"
        class="tw-pr-[6px] tw-pt-[4px]"
      >
      </gk-icon-button>
    </footer>
  </div>
</div>
